import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  height: 11px;
  border-radius: 8px;
  background-color: ${props => props.forDxf ? "#B7D6D5" : "#B7D6D5"};
  
  &.current {
    background-color: ${props => props.forDxf ? "#144344" : "#144344"};
  }
`;
export default function StepBar({isCurrent, forDxf=false}) {
    return (
        <Wrapper className={isCurrent ? 'current' : '' } forDxf={forDxf}></Wrapper>
    )
}